import script from "./RegisterAddress.vue?vue&type=script&setup=true&lang=js"
export * from "./RegisterAddress.vue?vue&type=script&setup=true&lang=js"

import "./RegisterAddress.vue?vue&type=style&index=0&id=58a75e86&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58a75e86"]])

export default __exports__